import { css } from 'linaria';
import { styled } from 'linaria/react';
import { FunctionalComponent, h } from 'preact';

import { cn } from 'libs/classnames';

export type TabItem = {
	title: string;
	key: string;
}
type TabsProps = {
	items: TabItem[];
	active: string;
	onChange: (key: string) => void,
	className?: string;
}

export const Tabs: FunctionalComponent<TabsProps> = (props) => {
	const { items, active, onChange, className } = props;

	return (
		<TabsContainer
			className={className}
		>
			{items.map(item => (
				<TabItemContainer
					key={item.key}
					onClick={() => onChange(item.key)}
					className={cn({
						[activeClass]: active === item.key,
					})}
				>
					{item.title}
				</TabItemContainer>
			))}
		</TabsContainer>
	);
};

const activeClass = css`
	color: var(--primary-color) !important;
	border-bottom-color: var(--primary-color) !important;
`;
const TabsContainer = styled('div')`
	display: flex;
	padding-left: 32px;
	border-bottom: 1px solid var(--button-outline-border);
`;
const TabItemContainer = styled('div')`
	padding: 0 0 8px;
	margin: 0 16px -1px;
	border-bottom: 2px solid transparent;
	cursor: pointer;
	transition: .3s ease-in-out;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 22px;
	color: var(--text-primary);
	
	&:first-child {
		margin-left: 0;
	}
	&:last-child {
		margin-right: 0;
	}
`;
